import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApplicationStates } from '../../../../../reducers/index.config';
import { RowsPerPage } from '../../../../../common/component/lists-table/table.config';
import type { ContactsListState } from '../../../../../core/interfaces/contact.interface';

export const initialContactListState: ContactsListState = {
    contactList: {
        listName: null,
        page: 1,
        pagination: RowsPerPage,
        totalRecords: 0,
        filters: {
            search: '',
        },
        currentListId: null,
        fetchedContacts: null,
        selectedRecordId: null,
        checkedContacts: [],
        exportInProgress: false,

    },
    loading: false,
    loaded: false,
    error: null,
};

export const getListState = createFeatureSelector<ContactsListState>(ApplicationStates.CONTACT_LIST);
export const getSelectedContact = createSelector(getListState, (state: ContactsListState) => {
    try {
        return state.contactList.selectedRecordId;
    } catch (e) {
        return null;
    }
});

export const getListFilter = createSelector(getListState, (state: ContactsListState) => ({
        page: state.contactList.page,
        pagination: state.contactList.pagination || RowsPerPage,
        filter: {
            search: state.contactList.filters.search,
        },
    }));

export const getAllFetchedRecords = createSelector(getListState, (state: ContactsListState) => state.contactList.fetchedContacts);
